export enum ChatUIDisplayMode {
	CHAT = 'chat',
	LANDING = 'landing'
}